import React from 'react';
import { Row, Col } from 'antd';
import moment, { Moment } from 'moment';

import { Sectors } from './Sectors';
import { Cellules } from './Cellules';
import { FileName } from './FileName';
import { Companies } from './Companies';
import { CreatedAt } from './CreatedAt';
import { Evaluators } from './Evaluators';
import { ReportName } from './ReportName';
import { Activities } from './Activities';
import { Workstations } from './Workstations';
import { Organizations } from './Organizations';
import type { FilterUrlParams, FormFields } from '../../types';
import { FilterCollapseForm } from '@/components/FilterCollapseForm';

interface FilterProps {
	queryParams: FilterUrlParams;
}

export function Filter({ queryParams }: Readonly<FilterProps>) {
	const initialValues: FormFields = mapFilterInitialValues(queryParams) ?? {};
	const queryParamsArray = Object.keys(queryParams);
	const filterValues = Object.values(queryParams).filter((params) => !!params);
	const hasSearchParams = filterValues.length > 0;
	const cleared = queryParamsArray[0] === 'cleared';

	function mapFilterInitialValues({ created_at }: FilterUrlParams): FormFields {
		return {
			...queryParams,
			created_at: created_at ? formatDateToInput(created_at) : undefined
		};
	}

	// function mapFilterInitialValues(queryParams: FilterRequest): FormFields {
	// 	const { start_date, end_date } = queryParams;
	// 	const created_at = start_date && end_date ? [moment(start_date), moment(end_date)] : undefined;
	// 	const initialValues: FormFields = { ...queryParams, created_at };
	// 	return initialValues;
	// }

	function formatDateToInput(created_at: string[]): Moment[] {
		const [startDate, endDate] = created_at;
		return [moment(startDate), moment(endDate)];
	}

	return (
		<FilterCollapseForm
			showSearchButton
			initialValues={initialValues}
			disableClearButton={!hasSearchParams || cleared}
		>
			<Col xs={24}>
				<Row gutter={[{ lg: 20 }, 0]}>
					<Col lg={24} xxl={12}>
						<ReportName />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Organizations />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Companies />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Sectors />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Cellules />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Workstations />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Activities />
					</Col>
					<Col lg={24} xxl={12}>
						<FileName />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<Evaluators />
					</Col>
					<Col lg={12} xl={8} xxl={6}>
						<CreatedAt />
					</Col>
				</Row>
			</Col>
		</FilterCollapseForm>
	);
}
